import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiDelete, operationsClient } from '@/lib/api';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';

export const useDeleteRole = createMutationHook<void, string>({
  mutationFn: (roleId) => apiDelete(operationsClient, settingsEndpoints.roleDetail(roleId)),
  onSuccess: (_data, _variables, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: settingsKeys.roles() });
    toast.success('Role deleted');
  },
});
